export var MiniGameId;
(function (MiniGameId) {
    MiniGameId["Gems"] = "gems";
    MiniGameId["WormApartment"] = "worm-apartment";
    MiniGameId["CatchSweets"] = "catch-sweets";
    MiniGameId["CardMagic"] = "card-magic";
})(MiniGameId || (MiniGameId = {}));
//# sourceMappingURL=MiniGame.js.map